import React from 'react';
import { Section } from './ui/Section';
import { Frown, Clock, DollarSign, Search } from 'lucide-react';
export function PainPointSection() {
  const painPoints = [{
    icon: <Search className="w-8 h-8 text-white" data-id="element-126" />,
    title: 'Horas buscando ideas en Pinterest',
    color: 'bg-coral'
  }, {
    icon: <DollarSign className="w-8 h-8 text-white" data-id="element-127" />,
    title: 'Gastando de más en decoraciones sueltas',
    color: 'bg-mint-dark'
  }, {
    icon: <Clock className="w-8 h-8 text-white" data-id="element-128" />,
    title: 'Corriendo a última hora',
    color: 'bg-partyPink-hot'
  }, {
    icon: <Frown className="w-8 h-8 text-white" data-id="element-129" />,
    title: 'Frustración porque nada combina',
    color: 'bg-yellow-400'
  }];
  return <Section className="bg-partyPink-light" data-id="element-130">
      <div className="text-center mb-12" data-id="element-131">
        <div className="inline-flex items-center justify-center mb-4" data-id="element-132">
          <span className="text-3xl mr-2" data-id="element-133">😰</span>
          <h2 className="text-3xl md:text-5xl font-black text-gray-800 uppercase tracking-widest" data-id="element-134">
            El Estrés
          </h2>
          <span className="text-3xl ml-2" data-id="element-135">😰</span>
        </div>
        <h3 className="text-4xl md:text-6xl font-script text-partyPink-hot mb-2" data-id="element-136">
          de cada fiesta es REAL
        </h3>
        <p className="text-2xl font-script text-gray-600" data-id="element-137">y lo sabemos...</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-12" data-id="element-138">
        {/* Left side - Photo placeholder */}
        <div className="bg-white p-4 rounded-2xl shadow-soft transform -rotate-2" data-id="element-139">
          <div className="aspect-video bg-gray-200 rounded-xl flex items-center justify-center overflow-hidden relative" data-id="element-140">
            <img src="https://cdn.magicpatterns.com/uploads/1mHP9yza9GRfaZgJQmgkx2/20260409_1212_Desafio_de_Decoracion_remix_01knrvmwdreq3snadqh8b1qmq3.png" alt="Mamá estresada organizando fiesta" className="object-cover w-full h-full opacity-80 mix-blend-multiply" data-id="element-141" />
            <div className="absolute inset-0 bg-partyPink-hot/10" data-id="element-142"></div>
            <div className="absolute bottom-4 left-4 right-4 bg-white/90 backdrop-blur-sm p-3 rounded-lg text-center shadow-sm" data-id="element-143">
              <p className="font-bold text-gray-800 text-sm" data-id="element-144">
                "¿Por qué organizar una fiesta tiene que ser tan complicado?"
              </p>
            </div>
          </div>
        </div>

        {/* Right side - Pain points */}
        <div className="flex flex-col justify-center space-y-4" data-id="element-145">
          {painPoints.map((point, index) => <div key={index} className="flex items-center bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-shadow transform hover:scale-[1.02]" data-id="element-146">
              <div className={`${point.color} w-14 h-14 rounded-full flex items-center justify-center shadow-inner flex-shrink-0`} data-id="element-147">
                {point.icon}
              </div>
              <p className="ml-4 font-semibold text-gray-700 text-lg" data-id="element-148">
                {point.title}
              </p>
            </div>)}
        </div>
      </div>

      <div className="text-center max-w-2xl mx-auto bg-white p-6 rounded-2xl shadow-soft border-2 border-partyPink border-dashed" data-id="element-149">
        <p className="text-xl text-gray-700 font-medium" data-id="element-150">
          No tienes que pasar por esto. Hemos creado la solución perfecta para
          que disfrutes el proceso tanto como la fiesta.
        </p>
      </div>
    </Section>;
}